import React, { useEffect, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Button, Modal, Table } from "react-bootstrap";
import sbi_logo from "../../../../src/assets/images/sbi_logo.png";
import EditProduct from "./EditProduct";
import AddProduct from "./AddProduct";
import {
  useGetProductListQuery,
  useGetProductbyIdQuery,
} from "./CommissionApiSlice";
import bob_img from "../../../assets/images/bob.webp";
import hdfc_logo from "../../../assets/images/HDFC.webp";
import sindBank from "../../../assets/images/sindBank.png";
import bandhan_bank from "../../../assets/images/bandhan_bank.jpg";

import { Divider } from "@mui/material";

const ProductMaster = () => {
  const [apiData, setApiData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [editProductModal, setEditProductModal] = useState(false);
  const [AddProductModel, setAddProductModal] = useState(false);
  const [cardName, setCardName] = useState("card_1");
  const [productCode, setProductCode] = useState("");

  const { data, isLoading, refetch } = useGetProductListQuery();

  const { data: productbyId } = useGetProductbyIdQuery(productCode);

  useEffect(() => {
    const dataFromApi = data?.data ? data?.data : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;
    setApiData(dataFromApi);
  }, [data, isLoading]);

  const filteredData = apiData?.filter((item) => {
    if (cardName === "card_1") {
      return item.bank_name === "State Bank of India";
    } else if (cardName === "card_2") {
      return item.bank_name === "Bank Of Baroda";
    } else if (cardName === "card_3") {
      return item.bank_name === "Punjab and Sind Bank";
    } else if (cardName === "card_4") {
      return item.bank_name === "Bandhan Bank";
    } else if (cardName === "card_5") {
      return item.bank_name === "HDFC";
    }
    return true;
  });

  const handleEditProduct = (product_code) => {
    setEditProductModal(true);
    setProductCode(product_code);
  };

  const handleCloseEditModal = () => {
    setEditProductModal(false);
    setProductCode("");
  };

  const handleAddProduct = () => {
    setAddProductModal(true);
  };
  const BANKS = [
    {
      key: "card_1",
      name: "State Bank of India",
      logo: sbi_logo,
      gradient: "gr-1",
    },
    {
      key: "card_2",
      name: "Bank Of Baroda",
      logo: bob_img,
      gradient: "gr-2",
    },

    {
      key: "card_3",
      name: "Punjab & Sind Bank",
      logo: sindBank,
      gradient: "gr-4",
    },
    {
      key: "card_4",
      name: "Bandhan Bank",
      logo: bandhan_bank,
      gradient: "gr-5",
    },
    {
      key: "card_5",
      name: "HDFC",
      logo: hdfc_logo,
      gradient: "gr-3",
    },
  ];

  return (
    <div className="">
      <Card className="mb-4">
        <CardBody>
          <div className="row g-4 px-3 d-flex justify-content-center">
            {BANKS.map((bank) => {
              const isActive = cardName === bank.key;

              return (
                <div
                  key={bank.key}
                  className="col-xl-2 col-lg-3 col-md-4 col-sm-6"
                >
                  <div
                    className={`bank-tile-lite ${isActive ? "active" : ""}`}
                    onClick={() => setCardName(bank.key)}
                  >
                    <div className="bank-logo-wrapper">
                      <img src={bank.logo} alt={bank.name} />
                    </div>
                    <span className="bank-name">{bank.name}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </CardBody>

        <Divider className="thick-divider" />

        {filteredData?.length > 0 ? (
          <div className="pt-3 px-5">
            <Col
              lg="12"
              className="d-flex justify-content-between align-items-center"
            >
              <h5 className="m-0">PRODUCTS</h5>

              <div className="d-flex align-items-center gap-3">
                <span className="text-muted">
                  Total :&nbsp;
                  <strong className="text-success">
                    {filteredData?.length || 0}
                  </strong>
                </span>

                <Button size="sm" onClick={handleAddProduct}>
                  <span className="mdi mdi-playlist-plus fs-6 me-1"></span>
                  Add Product
                </Button>
              </div>
            </Col>

            <Table striped responsive className="mt-3 table-container">
              <colgroup>
                <col style={{ width: "22%" }} />
                <col style={{ width: "48%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "10%" }} />
              </colgroup>

              <thead>
                <tr className="product_table">
                  <th>Product Category</th>
                  <th>Product Name</th>
                  <th>Commission (%)</th>
                  <th className="text-center">Edit</th>
                </tr>
              </thead>

              <tbody>
                {filteredData?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.product_category}</td>

                    <td
                      style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                    >
                      {item.product_name}
                    </td>

                    <td className="mx-3">
                      {/* <CurrencyRupeeIcon
                        className="fs-6 text-success"
                        style={{ marginTop: "-1%" }}
                      /> */}
                      {item.commission_percent} %
                    </td>

                    <td className="text-center">
                      <i
                        className="mdi mdi-text-box-edit-outline fs-5 cursor text-primary"
                        onClick={() => handleEditProduct(item.product_code)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <CardBody style={{ padding: "2%" }}>
            <div className="empty-state text-center">
              <i className="mdi mdi-database-off-outline fs-2 mb-2" />
              <p>No products available for this bank</p>
            </div>
          </CardBody>
        )}
      </Card>

      <Modal show={editProductModal} onHide={handleCloseEditModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold ">Edit Product</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "2.5%" }}>
          <div className="formdetails">
            <EditProduct
              productData={productbyId?.data}
              refetch={refetch}
              ModalState={setEditProductModal}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={AddProductModel}
        onHide={() => setAddProductModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold ">Add Product</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "2.5%" }}>
          <div className="formdetails">
            <AddProduct
              refetch={refetch}
              ModalState={setAddProductModal}
              cardName={cardName}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
    //  <div className="product-master-wrapper">
    //   <Card className="product-master-card mb-4">

    //     <CardBody className="pb-2">
    //       <div className="section-header">
    //         <h5>Select Bank</h5>
    //         <span className="section-subtitle">
    //           Choose a bank to manage products
    //         </span>
    //       </div>

    //       <div className="row g-4 px-3 mt-3 justify-content-center">
    //         {BANKS.map((bank) => {
    //           const isActive = cardName === bank.key;

    //           return (
    //             <div
    //               key={bank.key}
    //               className="col-xl-2 col-lg-3 col-md-4 col-sm-6"
    //             >
    //               <div
    //                 className={`bank-tile-lite ${isActive ? "active" : ""}`}
    //                 onClick={() => setCardName(bank.key)}
    //               >
    //                 <div className="bank-logo-wrapper">
    //                   <img src={bank.logo} alt={bank.name} />
    //                 </div>
    //                 <span className="bank-name">{bank.name}</span>
    //               </div>
    //             </div>
    //           );
    //         })}
    //       </div>
    //     </CardBody>

    //     <Divider className="thick-divider" />

    //     <CardBody className="pt-3">
    //       {filteredData?.length > 0 ? (
    //         <>
    //           <div className="product-header">
    //             <div>
    //               <h5 className="mb-0">Products</h5>
    //               <small className="text-muted">
    //                 Total products:{" "}
    //                 <strong className="text-success">
    //                   {filteredData.length}
    //                 </strong>
    //               </small>
    //             </div>

    //             <Button size="sm" onClick={handleAddProduct}>
    //               <i className="mdi mdi-plus-circle-outline me-1" />
    //               Add Product
    //             </Button>
    //           </div>

    //           <div className="table-container mt-3">
    //             <Table hover responsive className="product-table">
    //               <thead>
    //                 <tr>
    //                   <th>Category</th>
    //                   <th>Product Name</th>
    //                   <th>Commission (%)</th>
    //                   <th className="text-center">Action</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {filteredData.map((item, index) => (
    //                   <tr key={index}>
    //                     <td>{item.product_category}</td>
    //                     <td className="fw-semibold">{item.product_name}</td>
    //                     <td className="text-success fw-semibold">
    //                       <CurrencyRupeeIcon fontSize="small" />
    //                       {item.commission_percent}
    //                     </td>
    //                     <td className="text-center">
    //                       <i
    //                         className="mdi mdi-pencil-outline edit-icon"
    //                         onClick={() =>
    //                           handleEditProduct(item.product_code)
    //                         }
    //                       />
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </Table>
    //           </div>
    //         </>
    //       ) : (
    //         <div className="empty-state">
    //           <i className="mdi mdi-database-off-outline fs-2 mb-2" />
    //           <p>No products available for this bank</p>
    //         </div>
    //       )}
    //     </CardBody>
    //   </Card>

    // </div>
  );
};

export default ProductMaster;
